// extracted by mini-css-extract-plugin
module.exports = {"row":"row_56yhn","col":"col_c69wj","row1":"row1_dhjqa","col1":"col1_37zqy","row2":"row2_5milg","col2":"col2_eiz5u"};